export const PRICECODE_WEIGHTCONTROLLED = 3;
export const PRICECODE_NORMAL = 0;

export const DEPLOYMENT_ENVIRONMENTS = {
  DEVELOPMENT: 'DEVELOPMENT',
  TEST: 'TEST',
  STAGE: 'STAGE',
  PREVIEW: 'PREVIEW',
  PROD: 'PROD'
} as const;
export type DeploymentEnvironmentNames = (typeof DEPLOYMENT_ENVIRONMENTS)[keyof typeof DEPLOYMENT_ENVIRONMENTS];